import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-dominate-market',
  templateUrl: './dominate-market.component.html',
  styleUrls: ['./dominate-market.component.scss']
})
export class DominateMarketComponent implements OnInit {

  dominateDataList: any;
  dominateForm: FormGroup;
  productList: any;
  marketList: any;
  subProductList: any;
  cropList: any;
  isDominate: boolean = false;

  @ViewChild(MatSort) sort: MatSort;

  // table required variable
  dataSource: any;
  displayedColumns: string[] = ['marketName', 'crop', 'productType', 'subProductType', 'dominateMarket'];

  // pagination
  length: any;
  pageEvent: any;
  pageIndex: number = 0;
  pageSize: number = 10;

  constructor(private _userService: UserManagementService, private spinner: NgxSpinnerService, private toastr: ToastrService, private router: Router, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.formInIt();
    this.getDominateData(this.dominateForm.value);
    this.getMarketListData();
    this.getProductListData();
    this.getSubProductListData();
    this.getCropListData();
  }

  formInIt() {
    this.dominateForm = this.fb.group({
      marketName: [''],
      productType: [''],
      subProductType: [''],
      cropName: [''],
      isdominant:['']
    })

    this.dominateForm.valueChanges.subscribe(x => {
      console.log(x)
      this.getDominateData(x);
    })
  }

  backPage() {
    this.router.navigate(['/market-rate-historical-data']);
  }

  dominateFilterForm() {
    this.getDominateData(this.dominateForm.value)
  }

  clearFilter() {
    this.dominateForm.reset();
  }

  getMarketListData() {
    this._userService.getMarketlist().subscribe((data: any) => {
      this.marketList = data.result.data;
    });
  }

  getProductListData() {
    this._userService.getProductlistForHistorical().subscribe((data: any) => {
      this.productList = data.result.data;
    });
  }

  getSubProductListData() {
    this._userService.getSubProductTypeForHistorical().subscribe((data: any) => {
      this.subProductList = data.result.data;
    });
  }

  getCropListData() {
    this._userService.getCropList().subscribe((data: any) => {
      this.cropList = data.result.data;
    });
  }


  getServerData(event: any) {
    this.pageEvent = event;
    this.pageIndex = this.pageEvent.pageIndex;
    this.length = this.pageEvent.length;
    this.pageSize = this.pageEvent.pageSize;
    this.dataSource.sort = this.sort;

    this.getDominateData(this.dominateForm.value);
  }

  checkDominant(data, event: any) {

    let body = {
      marketId: data.marketID,
      cropId: data.cropId,
      productType: data.productTypeId,
      subProduct: data.subProductTypeId,
      isdominant: event.checked
    }

    this._userService.GetToggleStatusInDominate(body).subscribe((res: any) => {
      this.toastr.success(res.result.data)
      this.getDominateData(this.dominateForm.value);
    })
  }


  getDominateData(data: any) {
    this.spinner.show();
    this.dominateForm.value['pageNumber'] = this.pageIndex
    this.dominateForm.value['pageSize'] = this.pageSize

    let body = data;
    this._userService.getDominateMarketData(body).subscribe((res: any) => {
      this.dominateDataList = res.result.data
      this.spinner.hide();
      this.dataSource = new MatTableDataSource(this.dominateDataList.list);
      this.dataSource.sort = this.sort;
      this.pageIndex = this.dominateDataList.pageNumber;
      this.length = this.dominateDataList.totalItems;
    })
  }

}
